import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/outlet/device')({
  loader: () => {
    return {
      crumb: 'Perangkat',
    }
  },
})
